import React from "react";
import { CheckCircle2, Lock } from "lucide-react";

// Bloco clicável que acende quando escolhido (módulos, dados exigidos).
export default function Opcao({ icone: Icone, rotulo, dica, marcado, fixo = false, onAlternar, e2e }) {
  return (
    <button
      type="button"
      aria-pressed={marcado}
      disabled={fixo}
      onClick={onAlternar}
      data-e2e={e2e}
      className={`relative w-full text-left rounded-xl border-2 p-3.5 transition-all ${
        marcado ? "border-primary bg-primary/10" : "border-border hover:border-primary/40 hover:bg-muted/40"
      } ${fixo ? "cursor-not-allowed" : "active:scale-[0.98]"}`}
    >
      <span className="absolute top-2.5 right-2.5">
        {fixo ? <Lock className="w-4 h-4 text-muted-foreground" />
          : marcado ? <CheckCircle2 className="w-4 h-4 text-primary" />
            : <span className="block w-4 h-4 rounded-full border-2 border-muted-foreground/40" />}
      </span>
      <Icone className={`w-6 h-6 ${marcado ? "text-primary" : "text-muted-foreground"}`} />
      <p className={`mt-2 text-sm font-semibold leading-tight pr-5 ${marcado ? "" : "text-muted-foreground"}`}>{rotulo}</p>
      <p className="text-[11px] text-muted-foreground leading-snug mt-0.5">{dica}</p>
    </button>
  );
}
